<template>
  <q-layout>
    <q-ajax-bar ref="bar" position="top" color="red-4" size="3px" skip-hijack></q-ajax-bar>
    <q-page-container v-if="pageLoad">
      <q-page>
        <div class="row justify-between">
          <q-btn class="justify-center q-ma-xs q-pr-md" ripple dense flat color="black" @click="dialogExit = true">
            <q-icon name='arrow_left' style="font-size:2.5em"></q-icon> Quay lại
          </q-btn>
          <q-btn :loading="load" ripple icon="save" flat color="black" @click="dialogSubmit = true" size="20px"/>
        </div>
        <q-card class="q-my-xs q-pa-md" >
            <div class="text-h5 text-center q-py-md">Nhật ký thu hoạch</div>
            <div class="row">
              <div class="col-12 col-md-4 row items-center">
              <span class="text-weight-bold q-pb-md">Giám sát:</span>
              <span class="q-px-md q-pb-md" v-show="_.isEmpty(supervisors)">{{modelForShow.supervisor}}</span>
              <q-select
                class="q-px-md"
                style="min-width:200px"
                v-model="modelForShow.supervisor"
                v-show="!_.isEmpty(supervisors)"
                :error="errors.has('supervisor')"
                data-vv-validate-on="submitEvent"
                :error-message="errors.first('supervisor')"
                v-validate="'required'"
                ref = "supervisor"
                name = "supervisor"
                :options="supervisors"
                emit-value
                option-value="_id"
                :option-label="(item) => item.displayName ? item.displayName : item._id"
                :display-value="modelForShow.supervisor"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm q-mx-xs">
                  <div class="row">
                    <q-input class="col-10 self-center" v-model="modelDate" label="Ngày" readonly></q-input>
                    <q-btn icon="event" size="20px" style="height: 25%" flat class="col-2 cursor-pointer" @click="datePopUp = false">
                      <q-popup-proxy>
                        <q-date v-model="value" minimal v-close-popup="datePopUp"/>
                      </q-popup-proxy>
                    </q-btn>
                  </div>
              </div>
              <div class="col q-mx-xs">
                 <q-select
                 @blur="{}"
                :error="errors.has('farm')"
                data-vv-validate-on="blur|submitEvent"
                :error-message="errors.first('farm')" 
                v-validate="'required'"
                ref = "farm"
                name = "farm"
                emit-value v-model="modelForShow.farm" :options="farms" option-value="id" option-label="name" :display-value="$getNameById(farms, modelForShow.farm, 'name')" label="Nông trường">
                  <template v-slot:prepend>
                    <q-icon name="filter_vintage" />
                  </template>
                </q-select>
              </div>
              <div class="col q-mx-xs">
                <q-select
                 @blur="{}"
                :error="errors.has('lot')"
                data-vv-validate-on="blur|submitEvent"
                :error-message="errors.first('lot')"
                v-validate="'required'"
                ref = "lot"
                name = "lot"
                emit-value v-model="modelForShow.lot" :options="lots" option-value="id" option-label="name" :display-value="$getNameById(lots, modelForShow.lot, 'name')" label="Lô">
                  <template v-slot:prepend>
                    <q-icon name="local_florist" />
                  </template>
                </q-select>
              </div>
            </div>
            <span class="text-weight-bold" >Công việc</span>
            <div class="row">
              <q-select
                @blur="{}"
                :error="errors.has('job')"
                data-vv-validate-on="blur|submitEvent"
                :error-message="errors.first('job')"
                v-validate="'required'"
                ref = "job"
                name = "job"
                clearable
                :use-input="modelForShow.job === null || modelForShow.job === undefined"
                @filter="filterJob"
                emit-value class="col-12 col-sm q-mx-xs" v-model="modelForShow.job" :options="getJobs().sort((a, b) => a.name.localeCompare(b.name))" option-value="id" option-label="name" :display-value="$getNameById(jobStore.list, modelForShow.job, 'name')" label="Nội dung công việc">
                <template v-slot:prepend>
                  <q-icon name="pan_tool" />
                </template>
              </q-select>
              <q-input readonly class="col q-mx-xs" v-model="modelForShow.totalWeight" label="Tổng khối lượng" type="number" bottom-slots>
                <template v-slot:prepend>
                  <q-icon name="money" />
                </template>
              </q-input>
              <q-input readonly class="col q-mx-xs" v-model="unit" label="Đơn vị tính" type="text" bottom-slots>
                <template v-slot:prepend>
                  <q-icon name="local_atm" />
                </template>
              </q-input>
            </div>
            <span class="text-weight-bold" >Nhân công</span>
            <div class="row">
              <div class="col-12 col-sm q-mr-md">
                <span class="text-grey">Loại</span>
                <q-option-group
                  :error="errors.has('jobType')"
                  data-vv-validate-on="submitEvent"
                  :error-message="errors.first('jobType')"
                  v-validate="'required'"
                  ref = "jobType"
                  name = "jobType"
                  inline v-model="modelForShow.worker.type" :options="workerTypes"/>
              </div>
            <q-input bottom-slots
            @blur="{}"
            :error="errors.has('mekaNumber')"
            data-vv-validate-on="blur|submitEvent"
            :error-message="errors.first('mekaNumber')" 
            name="mekaNumber"
            ref="mekaNumber"
            v-validate="{min_value:0, required: true}"
            class="col q-mx-xs" v-model="modelForShow.worker.number" label="Số lượng" type="number">
              <template v-slot:prepend>
                <q-icon name="filter_9_plus" />
              </template>
            </q-input>
            <q-select
              :error="errors.has('meka')"
              @blur="{}"
                data-vv-validate-on="blur|submitEvent"
                :error-message="errors.first('meka')"
                v-validate="'required'"
                ref = "meka"
                name = "meka"
                @filter="filterMeka"
                :use-input="modelForShow.worker.meka === null || modelForShow.worker.meka === undefined"
                clearable
                emit-value bottom-slots class="col q-mx-xs" v-model="modelForShow.worker.meka" :options="mekas" option-value="id" option-label="displayName" :display-value="(modelForShow.worker && modelForShow.worker.meka) ? $getNameById(mekaStore.list, modelForShow.worker.meka, 'displayName') : ''" label="Meka">
              <template v-slot:prepend>
                <q-icon name="person" />
              </template>
            </q-select>
          </div>
      </q-card>

      <!-- Exit -->
      <q-dialog v-model="dialogExit" persistent>
        <q-card>
          <q-card-section class="row items-center">
            <q-avatar color="black" text-color="white">?</q-avatar>
            <span class="q-ml-sm">Bạn có muốn thoát ?</span>
          </q-card-section>
          <q-card-actions align="right">
            <q-btn ripple flat icon="clear" v-close-popup/>
            <q-btn ripple flat icon="done"  v-close-popup to="/harvest"/>
          </q-card-actions>
        </q-card>
      </q-dialog>
        <!-- Submit Data -->
      <q-dialog v-model="dialogSubmit" persistent>
        <q-card>
          <q-card-section class="row items-center">
            <q-avatar icon="save" color="black" text-color="white"/>
            <span class="q-ml-sm">Bạn có muốn lưu ?</span>
          </q-card-section>
          <q-card-actions align="right">
            <q-btn ripple flat icon="clear" v-close-popup/>
            <q-btn ripple flat icon="done"  v-close-popup @click="submitData()"/>
          </q-card-actions>
        </q-card>
      </q-dialog>
      
        <q-table
          :data="modelForShow.details"
          :columns="headers"
          row-key="name"
          no-data-label="Không có dữ liệu"
          :key="tableKey"
          :pagination= {rowsPerPage:0}
          :hide-bottom="!_.isEmpty(modelForShow.details)"
          >
          <template v-slot:top-right="props">
            <q-btn ripple dense icon="add" color="black" flat @click="addItem()" class="q-mr-md"/>
          </template>
          <template v-slot:body ="props">
            <q-tr :props="props" v-if="props.row.deleted !== true">
              <q-td >{{ props.row.__index + 1}}</q-td>
              <q-td v-if="props.colsMap.slot" class="label-xs-right text-center">{{ showSlots(props.row.slots)}} </q-td>
              <q-td v-if="props.colsMap.weight" class="label-xs-right text-center">{{ props.row.weight}}</q-td>
              <q-td v-if="props.colsMap.note" class="label-xs-right text-center">{{ props.row.note}}</q-td>
              <q-td v-if="props.colsMap.actions" class="label-xs-right text-center">
                <q-btn ripple flat round color="black" icon="edit" @click="clickEditButton(props)" />
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <!-- Edit form -->
    <q-dialog  v-if="dialogEdit" v-model="dialogEdit" persistent :key="dialogKey" >
      <q-card style="width:100vw; max-width:800px">
        <q-card-section>
          <div class="text-h6">Nhập dữ liệu</div>
        </q-card-section>
        <!-- Form render -->
        <q-card-section>
          <q-input
            bottom-slots
            @blur="{}"
            :error="errors.has('weight')"
            data-vv-validate-on="blur|submitEvent"
            :error-message="errors.first('weight')" 
            name="weight"
            ref="weight"
            v-validate="{min_value:0, required: true}"
            class="q-py-xs" v-model="model.weight" label="Khối lượng" type="number" :rules="[val => val > 0 ]">
              <template v-slot:prepend>
                <q-icon name="fitness_center" />
              </template>
            </q-input>
            <!-- eslint-disable-next-line -->
            <div class="q-pt-md">Ô :</div>
            <div class="row q-py-xs" :key="modelKey">
              <q-chip class="col-5 col-sm-3 col-md-2" v-for="(item) in model.slots" :key="item.name" :selected.sync="item.picked" emit-value :color="!item.picked ? 'grey' : 'primary' " text-color="white" @click="modelKey++">
                <div class="text-center break-word" style="text-overflow: ellipsis; overflow: hidden;white-space: nowrap;"> {{item.name}} </div>
              </q-chip>
            </div>
          
          <q-input v-model="model.note" filled type="textarea" label="Ghi chú">
            <template v-slot:prepend>
              <q-icon name="create" />
            </template>
          </q-input>

        </q-card-section>
        <!-- Functions -->
        <q-card-actions align="right">
          <q-btn v-if="!isAdding" flat ripple round icon="delete" @click="dialogDel = true"/>
          <q-btn ripple flat icon="clear" @click="resetData()" v-close-popup/>
          <q-btn flat ripple icon="done" @click="submitModel()" />
        </q-card-actions>
      </q-card>
      <!-- Delete Record -->
      <q-dialog v-model="dialogDel" persistent>
        <q-card>
          <q-card-section class="row items-center">
            <q-avatar icon="delete" color="black" text-color="white"/>
            <span class="q-ml-sm">Bạn có chắc chắn muốn xóa ?</span>
          </q-card-section>
          <q-card-actions align="right">
            <q-btn ripple flat icon="clear" v-close-popup/>
            <q-btn ripple flat icon="done"  v-close-popup @click="deleteItem()"/>
          </q-card-actions>
        </q-card>
      </q-dialog>
    </q-dialog>
        <!-- Camera -->
      <q-dialog v-if="dialogCam" v-model="dialogCam" persistent>
        <q-card class="camera-wrap">
          <q-card-section class="text-right">
            <q-btn round flat icon="clear" v-close-popup  @click="stop()"/>
          </q-card-section>
          <q-card-section class="text-center camera-section relative">
          <div v-show="camIsOn" class="absolute q-px-lg q-py-xs text-red">
            {{ moment(new Date()).format(showDateFormat)}} {{location.latitude + ' ' + location.longitude}}
          </div>
            <video ref='video' playsinline autoplay :width="$q.screen.width-100" v-show="camIsOn"></video>
            <img ref='videoImg' :src='model.pic' :width="$q.screen.width-100" v-show="!camIsOn"/>
            <canvas ref='canvas' style='display:none'></canvas>
          </q-card-section>
          <q-card-actions class="justify-center items-center" align="center">
            <q-btn color="black" round icon="switch_camera" @click='flip()'/>
            <q-btn size="20px" round color='black' :icon="camIsOn ? 'camera' : 'cached' " @click='capture()'/>
            <q-btn color="black" round icon="done" @click='camDone()'/>
          </q-card-actions>
        </q-card>
      </q-dialog>
      </q-page>
    </q-page-container>
  </q-layout>
</template>


<script>
/* eslint-disable */
import moment from 'moment'
import { firebase } from '@firebase/app'
import { date } from 'quasar'
import reportData from 'src/modules/reports/components/reportData/reportData.vue'
export default {
  mixins: [reportData],
  data() {
    return {
      headers: [{
          label: "No",
          align: "left",
          name: "no"
        },
        {
          label: "Ô",
          align: "center",
          name: "slot"
        },
        {
          label: "Khối lượng",
          align: "center",
          name: "weight"
        },
        {
          label: "Ghi chú",
          align: "center",
          name: "note"
        },
        {
          label: "Thao tác",
          align: "center",
          name: "actions"
        }
      ],
    }
  },
  methods: {
    getJobs() {
      let acceptId = ['chichbap', 'baobuong', 'thubq', 'catbup']
      let filterd = this._.get(this.$store.getters, 'jobStore.list') ? this.$store.getters.jobStore.list.filter(item => acceptId.indexOf(item.id) !== -1) : []
      return filterd
    },
    getReports(id) {
      return this.$query(['Harvest', id], ['deleted', '==', false])
    },
    submitData() {
      let vm = this
      vm.validate()
      vm.$nextTick(()=> {
        if (vm.errors.items.length > 0 ) {
          vm.$q.notify({
            message: 'Lưu thất bại',
            color: 'red',
            icon: 'error'
          })
          return
        }
        else {
          vm.loading(true)
          vm.modelForShow.yearMonth = vm.yearMonth
          let submitModel = { id: vm.reportId, data: vm._.cloneDeep(vm.modelForShow)}
          vm.$command.execute('updateHarvest', submitModel).then( () => {
            vm.loading(false)
            vm.$q.notify({
              message: 'Đã lưu thành công',
              color: 'black',
              icon: 'check'
            })
            if (vm.mode === 'CREATE' || !vm.reportId) {
              vm.$router.push('/harvest')
            }
          }).catch((error) => {
            vm.loading(false)
            vm.$q.notify({
              message: 'Lưu thất bại: ' + error.message, //`${error}`,
              color: 'red',
              icon: 'error'
            })
          })
        }
      })
    },
  }
}
</script>
